var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgErrorInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.337 0L6.67032 2.96037e-05C2.98842 3.50674e-05 0.00366211 2.98481 0.00366211 6.6667V20.0596C0.00366211 23.7415 2.98843 26.7263 6.67033 26.7263H9.41969L13.9259 30.5036C14.5425 31.0204 15.4403 31.023 16.0598 30.5097L20.6266 26.7263L23.337 26.7263C27.0189 26.7262 30.0037 23.7415 30.0037 20.0596V6.66667C30.0037 2.98476 27.0189 -5.46372e-06 23.337 0ZM15 7.5C15.9205 7.5 16.6667 8.24619 16.6667 9.16667V12.5C16.6667 13.4205 15.9205 14.1667 15 14.1667C14.0795 14.1667 13.3333 13.4205 13.3333 12.5V9.16667C13.3333 8.24619 14.0795 7.5 15 7.5ZM15 15.4167C13.8494 15.4167 12.9167 16.3494 12.9167 17.5C12.9167 18.6506 13.8494 19.5833 15 19.5833C16.1506 19.5833 17.0833 18.6506 17.0833 17.5C17.0833 16.3494 16.1506 15.4167 15 15.4167Z",
    fill: "#F77272"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorInfo);
export default __webpack_public_path__ + "static/media/error-info.90f0302e052a578f92e48f06db370643.svg";
export { ForwardRef as ReactComponent };